import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <App
    filmLocationAPIUrl={process.env.REACT_APP_FILM_LOCATION_API_URL}
    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
  />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
